import type { RouteRecordMainRaw } from '@fantastic-admin/types'
import { apiRequest } from '../client'

export default {
  // 后端获取路由数据
  routeList: () => apiRequest<RouteRecordMainRaw[]>('/app/route/list'),

  // 登录
  login: (data: {
    account: string
    password: string
  }) => apiRequest<{ account: string, token: string, avatar: string }>('/app/account/login', {
    method: 'POST',
    auth: false,
    body: data,
  }),

  // 获取权限
  permission: () => apiRequest<{ permissions: string[] }>('/app/account/permission'),

  // 修改密码
  passwordEdit: (data: {
    password: string
    newPassword: string
  }) => apiRequest<Record<string, never>>('/app/account/password/edit', {
    method: 'POST',
    body: data,
  }),
}
